module.exports = __webpack_public_path__ + "img/jdlhz-icon.894a6a82.png";